import { useCallback } from "react";
import { ErrorResponse } from "@core/types/errorResponse";
import { useErrorModalStore } from "@infrastructure/api/store/errorModalStore";
import { kpiConflictFromError, errorsHasUnhandledNonStringValues, stringValidationMessagesFromErrors } from "@features/admin/kpi/utils/kpiConflictFromError";

export function useApiError() {
  const { showValidation, showKpiConflict, showSystem } = useErrorModalStore();

  return useCallback((error: ErrorResponse) => {
    const status = error?.statusCode ?? 0;
    const isClientError = status >= 400 && status < 500;

    const conflict = kpiConflictFromError(error);
    if (conflict) {
      showKpiConflict(conflict);
      return;
    }

    const stringMessages = stringValidationMessagesFromErrors(error?.errors);
    if (stringMessages.length > 0) {
      showValidation(stringMessages);
      return;
    }

    if (error?.errors && errorsHasUnhandledNonStringValues(error.errors) && error.detail) {
      showValidation([error.detail]);
      return;
    }

    if (isClientError && error?.detail) {
      showValidation([error.detail]);
    } else if (error?.detail) {
      showSystem(error.detail);
    } else {
      showSystem();
    }

    if (process.env.NODE_ENV === "development" && error?.trace?.length) {
      console.error("Trace:", error.trace);
    }
  }, [showSystem, showValidation, showKpiConflict]);
}
